import { parseStack } from "./parseStack";
export function processCommonError(e, filename, lineno, colno, error) {
    try {
        if (typeof e === "string") {
            return getSendData({
                message: e,
                filename: filename,
                lineno: lineno,
                colno: colno,
                error: error
            });
        }
        return getSendData(e);
    } catch (err) {
    /* empty */ }
}
export function processUnhandleDrejection(e) {
    if (!e) return;
    try {
        var message = "";
        var lineno = 0;
        var colno = 0;
        var filename = "";
        var stack = "";
        if (typeof e === "string") {
            message = e;
        } else if (typeof e.reason === "object") {
            message = e.reason.message;
        } else if (typeof e.message === "string") {
            message = e.message;
        }
        var reason = e.reason;
        if (typeof reason === "object") {
            if (typeof reason.column === "number") {
                colno = reason.column;
                lineno = reason.line;
            } else if (reason.stack) {
                var matchR = reason.stack.match(/at\s+.+:(\d+):(\d+)/);
                if (matchR) {
                    lineno = matchR[1];
                    colno = matchR[2];
                }
            }
            if (reason.sourceURL) {
                filename = reason.sourceURL;
            } else if (reason.stack) {
                var matchR1 = reason.stack.match(/at\s+(.+):\d+:\d+/);
                if (matchR1) {
                    filename = matchR1[1];
                }
            }
            if (reason.stack) {
                stack = reason.stack;
            }
        }
        return getSendData({
            message: message,
            filename: filename,
            lineno: lineno,
            colno: colno,
            stack: stack,
            error_type: e.constructor.name
        });
    } catch (err) {
    /* empty */ }
}
function getErrorType(e) {
    var pattern = e.message.match(/Uncaught (\w+):/);
    if (pattern && pattern[1]) return pattern[1];
    else if (e.error_type) return e.error_type;
    else if (e.name) return e.name;
    else return "";
}
function getSendData(e) {
    var _e_message = e.message, message = _e_message === void 0 ? "" : _e_message, lineno = e.lineno, colno = e.colno, stack = e.stack, error = e.error;
    // stack解析成三段，避免过长
    var stacks = parseStack(error && error.stack || stack) || [
        "",
        "",
        ""
    ];
    var sendData = {
        msg: message || e.msg || "",
        lineno: lineno,
        colno: colno,
        file: e.filename || e.file || "",
        stack: error && error.stack || stack,
        stack1: stacks[0],
        stack2: stacks[1],
        stack3: stacks[2],
        errType: e.errType || getErrorType(e) || "",
        errCode: e.errCode || e.error_code
    };
    return sendData;
}

 //# sourceMappingURL=processError.js.map